import { render, staticRenderFns } from "./JcomGrowthReport.vue?vue&type=template&id=66065da6"
import script from "./JcomGrowthReport.vue?vue&type=script&lang=js"
export * from "./JcomGrowthReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports